import { render, staticRenderFns } from "./CandidateResume.vue?vue&type=template&id=c8fbae0c&scoped=true&"
import script from "./CandidateResume.vue?vue&type=script&lang=ts&"
export * from "./CandidateResume.vue?vue&type=script&lang=ts&"
import style0 from "./CandidateResume.vue?vue&type=style&index=0&id=c8fbae0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fbae0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAlert,VBtn,VFileInput,VForm,VIcon,VProgressLinear})
